module.exports = __webpack_public_path__ + "img/ic-layouts-hover.c061e0bb.svg";